import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';
import { promoBannerStyles } from './PromoBanner.styles';

export type PromoBannerVariant = keyof typeof promoBannerStyles.variant;

export type PromoBannerProps = {
  title: string;
  description?: string;
  ctaLabel: string;
  ctaHref: string;
  imageSrc?: string;
  variant?: PromoBannerVariant;
  className?: string;
};

export function PromoBanner({
  title,
  description,
  ctaLabel,
  ctaHref,
  imageSrc,
  variant = 'dark',
  className,
}: PromoBannerProps): JSX.Element {
  return (
    <section
      className={cn(promoBannerStyles.root, promoBannerStyles.variant[variant], className)}
      style={
        imageSrc
          ? {
              backgroundImage: `linear-gradient(rgba(7,25,36,0.85), rgba(7,25,36,0.85)), url(${imageSrc})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          : undefined
      }
    >
      <div className={promoBannerStyles.inner}>
        <div className={promoBannerStyles.text}>
          <h2 className={promoBannerStyles.title}>{title}</h2>
          {description ? <p className={promoBannerStyles.description}>{description}</p> : null}
        </div>
        <Link to={ctaHref}>
          <Button
            type="button"
            variant={variant === 'light' ? 'primary' : 'outline'}
            className={variant === 'light' ? undefined : 'border-brand-200 text-brand-100 hover:bg-brand-900'}
          >
            {ctaLabel}
          </Button>
        </Link>
      </div>
    </section>
  );
}
